import type { MediationTranslationView, TranslationObjectType } from "@expertloop/shared";

/** Langue d'affichage choisie par le membre du support (LANG-3). */
export type TranslationViewMode = "reference" | "original" | "dossier" | "mine";

export interface TextKey {
	objectType: TranslationObjectType;
	objectId: string;
	field: string;
}

export type PickedTranslation =
	| { kind: "original" }
	| { kind: "translated"; content: unknown; sourceLocale: string | null }
	| { kind: "same_language"; locale: string }
	| { kind: "missing"; sourceLocale: string | null };

/**
 * Ce qu'il faut afficher pour un texte du dossier. L'original reste la référence : sans
 * traduction prête, ou en mode « original », c'est lui qui est montré.
 */
export function pickTranslation(
	view: MediationTranslationView | undefined,
	mode: TranslationViewMode,
	key: TextKey,
	/** Langue du membre du support, pour le mode « ma langue ». */
	mineLocale?: string,
): PickedTranslation {
	if (!view || mode === "original") return { kind: "original" };
	const locale = mode === "reference" ? view.referenceLocale : mode === "dossier" ? view.dossierLocale : (mineLocale ?? view.referenceLocale);
	const entry = view.entries.find(
		(candidate) => candidate.objectType === key.objectType && candidate.objectId === key.objectId && candidate.field === key.field,
	);
	if (!entry) return { kind: "original" };
	const translated = entry.translations[locale];
	if (translated?.state === "ready" && translated.content !== undefined) {
		return { kind: "translated", content: translated.content, sourceLocale: entry.sourceLocale };
	}
	if (entry.sourceLocale === locale) return { kind: "same_language", locale };
	return { kind: "missing", sourceLocale: entry.sourceLocale };
}
